<div class="new-content" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="teacher-drag-scroll">
    <div class="pane-header" [class.mobile]="deviceService.isMobile()">
    <app-library-title [title]="titleAllBottom" [class.with-sorting]="_pane.show_sorting">
      <ng-container side>
        <span class="subtitle normal">{{ this.blockTitle.subtitle | customLocale }}</span>
      </ng-container>
    </app-library-title>
    <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
    </div>

    <ng-template [ngIf]="users && users.length > 0">
      <ng-template [ngIf]="isDragScrollEnabled && isBrowser" [ngIfElse]="responsiveScroll">
        <div class="carousel">
          <ng-template [ngIf]="users.length > 2">
            <div class="right-btn" (click)="moveRight()">
              <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
            </div>

            <div class="left-btn" (click)="moveLeft()">
              <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
            </div>
          </ng-template>

          <cdk-virtual-scroll-viewport #scroller
                                       [itemSize]="itemSize"
                                       class="scroll-viewport"
                                       orientation="horizontal">
            <div *cdkVirtualFor="let user of users; let i = index; trackBy: trackUserByFn" class="scroll-item"
                 (click)="onOpenCard(i)">
              <app-user-mini-card [user]="user"></app-user-mini-card>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </ng-template>

      <ng-template #responsiveScroll>
        <div class="responsive-scroll-viewport">
          <div *ngFor="let user of users; let i = index; trackBy: trackUserByFn" class="scroll-item"
               (click)="onOpenCard(i)">
            <app-user-mini-card [user]="user"></app-user-mini-card>
          </div>
        </div>
      </ng-template>
    </ng-template>

  </div>
</ng-template>

<app-modal *ngIf="deviceService.isDesktop() && showModal"
           [canClose]="false"
           [additionalHeight]="80"
           (closed)="onCloseModal($event)"
           [prevNext]="true"
           [reachedPrev]="reachedPrev"
           [reachedNext]="reachedNext"
           (togglePrev)="togglePrev($event)"
           (toggleNext)="toggleNext($event)">
  <app-modal-body>
    <app-user-profile-page
      [userName]="item.slug"
      [selectedSubjectId]="getSubjectId"
      [isModal]="showModal">
    </app-user-profile-page>
  </app-modal-body>
  <app-modal-ad>
    <app-teacher-booking-surface-block [teacher]="item"></app-teacher-booking-surface-block>
  </app-modal-ad>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop() && showModal"
                  (closed)="onCloseModal($event)">
  <app-mobile-modal-body>
    <app-user-profile-page
      [userName]="item.slug"
      [selectedSubjectId]="getSubjectId"
      [isModal]="showModal">
    </app-user-profile-page>
  </app-mobile-modal-body>

  <app-mobile-modal-actions></app-mobile-modal-actions>
</app-mobile-modal>
